import css from "./Input.module.css";

import React from "react";
import clsx from "clsx";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  required?: boolean;
  label?: string;
  error?: string; // сообщение об ошибке
  helperText?: string; // дополнительный текст под полем
  hasGlobalError?: boolean;
};

export function Input({
  label,
  error,
  hasGlobalError,
  helperText,
  required,
  ...props
}: InputProps) {
  return (
    <div className={css.root}>
      {label && (
        <label
          className={clsx(
            css.label,
            (error || hasGlobalError) && css.labelError
          )}
        >
          {label}
          {required && !error ? (
            <span className={css.required}>*</span>
          ) : (
            <span className={css.errorText}> - {error}</span>
          )}
        </label>
      )}
      <input className={clsx(css.input, error && css.inputError)} {...props} />
      {helperText && <div className={css.helperText}>{helperText}</div>}
    </div>
  );
}
